<template>
	<div>

	</div>
</template>

<script>
export default {
  name: 'reportList',
  data () {
    return {
    }
  },
  created:function(){
    this.getList();
  },
  methods:{
    getList(){
      var institution_id = sessionStorage.getItem('insituation');
      var openid = JSON.parse(localStorage.getItem('user')).openid;
      console.log('institutions/'+institution_id+'/users/'+openid+'/assesses');
      http.get('institutions/'+institution_id+'/users/'+openid+'/assesses').then(function(res) {
      	console.log(res);
      }).catch(function(res) {

      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/reportList.vue